var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _vm.title.length > 0
        ? _c("label", { staticClass: "title" }, [
            _vm._v(" " + _vm._s(_vm.title) + " "),
            _vm.required
              ? _c("span", { staticClass: "text-danger" }, [_vm._v("*")])
              : _vm._e(),
          ])
        : _vm._e(),
      _c("br"),
      _vm._l(_vm.options, function (option) {
        return _c(
          "div",
          {
            key: option.value,
            staticClass: "custom-control custom-radio custom-control-inline",
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form[_vm.name],
                  expression: "form[name]",
                },
              ],
              staticClass: "custom-control-input",
              attrs: {
                type: "radio",
                id: "option_" + option.value,
                name: _vm.name,
              },
              domProps: {
                value: option.value,
                checked: _vm._q(_vm.form[_vm.name], option.value),
              },
              on: {
                input: _vm.changedRadio,
                change: function ($event) {
                  return _vm.$set(_vm.form, _vm.name, option.value)
                },
              },
            }),
            _c(
              "label",
              {
                staticClass: "custom-control-label",
                attrs: { for: "option_" + option.value },
              },
              [_vm._v(_vm._s(option.name))]
            ),
          ]
        )
      }),
      _c("suc-field-has-error", { attrs: { form: _vm.form, field: _vm.name } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }